import * as React from "react";
import { dots } from "./dots";

import "./index.css";

function LoadingDots(props) {
	const { show, children } = props;

	if (show) {
		return (
			<div className="Loader__background">
				<div className="Loader__foreground">
					<div className="Loader__message">{dots}</div>
				</div>
			</div>
		);
	}

	// eslint-disable-next-line react/jsx-no-useless-fragment
	return <>{children}</>;
}

export default LoadingDots;
